import { Alert, AlertTitle, Typography } from '@mui/material'
import { HourglassEmpty, CheckCircle } from '@mui/icons-material'

interface MSPStatusBannerProps {
  relationshipStatus: string | null
  mspCompanyName?: string | null
}

export default function MSPStatusBanner({ relationshipStatus, mspCompanyName }: MSPStatusBannerProps) {
  // Don't show banner if no status or if already fully verified
  if (!relationshipStatus || relationshipStatus === 'Verified') {
    return null
  }

  // Waiting or DNSVerified - show orange banner
  if (relationshipStatus === 'waiting' || relationshipStatus === 'DNSVerified') {
    return (
      <Alert 
        severity="warning" 
        icon={<HourglassEmpty />}
        sx={{ mb: 3 }}
      >
        <AlertTitle>
          {relationshipStatus === 'waiting' 
            ? 'MSP Verification Pending - DNS Setup Required' 
            : 'MSP Verification Pending - Awaiting MSP Action'}
        </AlertTitle>
        <Typography variant="body2">
          {relationshipStatus === 'waiting' 
            ? 'You have generated a verification code. Complete the DNS TXT record setup and verify it to proceed.'
            : 'Your DNS record has been verified. Forward the email instructions to your MSP partner to complete the setup.'}
        </Typography>
      </Alert>
    )
  }

  // Accepted - show green banner
  if (relationshipStatus === 'Accepted') {
    return (
      <Alert 
        severity="success" 
        icon={<CheckCircle />}
        sx={{ mb: 3 }}
      >
        <AlertTitle>MSP Access Established</AlertTitle>
        <Typography variant="body2">
          {mspCompanyName 
            ? `${mspCompanyName} now has access to your TC-Config portal.`
            : 'Your MSP partner now has access to your TC-Config portal.'}
        </Typography>
      </Alert>
    )
  }

  return null
}
